<ngx-spinner
  [fullScreen]="fullScreen"
  [type]="type"
  [size]="size"
></ngx-spinner>
